import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Provider } from "react-redux";
import { Router, Route, Switch, useLocation } from "react-router-dom";
import { createBrowserHistory } from "history";

import { ACTIONS as DATA_ACTIONS } from "./reducers/DataReducer";
import sanityclient from "./client";
import Store from "./Store";

import { Grid, Col, Row, OverviewPage } from "./theme";
import "./assets/fonts/";

import Home from "./components/Home";
import Header from "./components/header";
import About from "./components/about";
import Footer from "./components/footer";
import Nav from "./components/nav";
import Voter from "./components/vote";
import Edition from "./components/edition";
import Education from "./components/education";
import Schedule from "./components/schedule";
import AllMemes from "./components/allMemes";
import SimpleGallery from "./components/SimpleGallery";
import Editions from "./components/Editions";
import MemeTable from "./components/memeTable";
import ImageFullView from "./components/ImageFullView";
import EditionDownloads from "./components/EditionDownloads";
import Admin from "./components/Admin";
import TaggerInsights from "./components/TaggerInsights";
import Tagger from "./components/Tagger";

const DataHelper = () => {
  const data = useSelector((state) => state.data);
  const dispatch = useDispatch();
  useEffect(() => {
    if (!data.client && dispatch) {
      const cli = sanityclient(dispatch);
      dispatch({ type: DATA_ACTIONS.SET_CLIENT, client: cli });
    }
  });
  return null;
};

const LayoutRoutes = () => {
  return (
    <>
      <Header />
      <Grid style={{ minHeight: "85vh" }}>
        <Row center="xs">
          <Col xs={12} sm={12} md={12} lg={12}>
            <Row>
              <Col xs={false} sm={false} md={3} lg={2}>
                <Nav />
              </Col>
              <Col xs={12} sm={12} md={9} lg={10}>
                <Switch>
                  <Route exact path="/" component={Home} />
                  <Route exact path="/overview" component={OverviewPage} />
                  <Route exact path="/about" component={About} />
                  <Route exact path="/vote" component={Voter} />
                  <Route exact path="/edition/:slug" component={Edition} />
                  <Route exact path="/edition" component={Edition} />
                  <Route exact path="/education" component={Education} />
                  <Route exact path="/schedule" component={Schedule} />
                  <Route exact path="/memes" component={AllMemes} />
                  <Route exact path="/admin" component={Admin} />
                  <Route
                    exact
                    path="/taggerinsights"
                    component={TaggerInsights}
                  />
                  <Route exact path="/tagger/:memeId" component={Tagger} />
                  <Route exact path="/tagger" component={Tagger} />
                  <Route exact path="/table" component={MemeTable} />
                  <Route exact path="/downloads" component={EditionDownloads} />
                  <Route
                    exact
                    path="/editions/:editionId?"
                    component={Editions}
                  />
                  <Route
                    exact
                    path="/simple/:edition"
                    component={SimpleGallery}
                  />
                  <Route component={Home} />
                </Switch>
              </Col>
            </Row>
          </Col>
        </Row>
      </Grid>
      <Footer />
    </>
  );
};

const FullscreenRoutes = () => (
  <Switch>
    <Route exact path="/gallery/:id" component={ImageFullView} />
  </Switch>
);

const MainRouter = () => {
  const location = useLocation();
  const isFullscreen = location.pathname.startsWith("/gallery/");

  return isFullscreen ? <FullscreenRoutes /> : <LayoutRoutes />;
};

const App = () => {
  const history = createBrowserHistory();

  return (
    <Provider store={Store}>
      <DataHelper />
      <Router history={history}>
        <MainRouter />
      </Router>
    </Provider>
  );
};

export default App;
